define('admin',['jquery', 'core'], function($, core) {
    'use strict';

    var module = {};

    module.attach = function (context) {
        module.onChangeUserStatusCheckboxClick(context);
        module.sidebarMenu(context);
        module.profileMenu(context);

        module.onOrderItemQuantityChange(context);
        module.onProposePartialOrderSubmit(context);
    };

    module.onChangeUserStatusCheckboxClick = function (context) {
        context.andFind('.js-change-user-status-checkbox').click(function () {
            var self = $(this),
                userId = self.data('id'),
                checked = self[0].checked;
            context.andFind('.js-user-status-id-field').val(userId);
            context.andFind('.js-user-check-box-status-id-field').val(checked);
            context.andFind('.js-change-user-status-form').submit();
        });
    };

    module.sidebarMenu = function (context) {
        var trigger = context.andFind('.js-navigation').children('a'),
            self;

        trigger.on('click', function (event) {
            self = $(this);
            if (self.next('.js-sub-nav').length && !self.hasClass('active-submenu')) {
                event.preventDefault();
                $('.active-submenu').removeClass('active-submenu');
                self.addClass('active-submenu');
            }
            else {
                if (self.hasClass('active-submenu')) {
                    event.preventDefault();
                    self.removeClass('active-submenu');
                }
            }
        });

        return this;
    };

    module.profileMenu = function (context) {
        var trigger = context.andFind('.js-open-dropdown'),
            wrapperBlock = $('.dropdown'),
            self,
            sync;

        trigger.on('click', function (event) {
            self = $(this);
            sync = trigger.not(this);
            sync.parent(wrapperBlock).removeClass('active');

            self.parent(wrapperBlock).toggleClass('active');

            event.stopPropagation();
        });

        //hide dropdown when clicked on body
        $(document).on('click', function () {
            $('.dropdown').removeClass('active');
        });

        return this;
    };

    module.onOrderItemQuantityChange = function (context) {
        context.andFind('.js-order-item-quantity').change(function () {
            var $form = $('.js-propose-partial-order-form');
            $form.attr('action', $form.data('recalculate-url'));
            core.dom.doAction($form);
        });
    }

    module.onProposePartialOrderSubmit = function(context) {
        context.andFind('.js-propose-partial-order-form').submit(function (e) {
            e.preventDefault();

            var $form = $('.js-propose-partial-order-form');
            $form.attr('action', $form.data('submit-url'));
            core.dom.doAction($form);
        });
    }

    core.scopes.on("adminUpdateOrderRow", function (event, orderData, context) {
        $('.js-admin-order-status[data-order-id="' + orderData.OrderId + '"]').html(orderData.OrderStatusText);

        if (orderData.OrderAmountText) {
            $('.js-admin-order-amount[data-order-id="' + orderData.OrderId + '"]').html(orderData.OrderAmountText);
        }
    });

    core.scopes.on("updateTrackingNumbers", function (event, orderData, context) {
        $('.js-admin-order-actions[data-order-id="' + orderData.OrderId + '"]').remove();
        $('.js-admin-order-tracking-numbers[data-order-id="' + orderData.OrderId + '"]').html(orderData.TrackingNumbers.replace(/\n/g, '<br/>'));
    });

    // Initialize
    $(document).ready(function () {
        core.scopes.addHandler('*', function (context) {
            module.attach(context);
        });
    });

    return module;
});
